@if (admin$ | async; as admin) {
  <zah-upsert-admin
    [admin]="admin"
    okLabel="Bewaar"
    (cancelClicked)="onCancelClicked()"
    (okClicked)="onEditClicked($event)">
  </zah-upsert-admin>
}
